//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('eCommerceStatus', {
//        templateUrl: 'views/components/views/eCommerceStatus/eCommerceStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['translateService', 'modalService', 'eCommerceStatusService', function (translateService, modalService, eCommerceStatusService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let translations = {
//                ecommerce_status_update: '',
//            	ok: ''
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//            	let data = await translateService.translateBatch(translations);

//            	Object.keys(translations).forEach((key) => {
//            		if (data?.[key]) translations[key] = data[key];
//            	});
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.updateWebShop = function () {
//                eCommerceStatusService.startSync().then(function (response) {
//                    modalService.show({
//                        type: 'success',
//                    	title: translations.ecommerce_status_update,
//                        message: response[0].statusmessage,
//                    	buttons: [{
//                    		label: translations.ok,
//                    		cssClass: 'btn-success',
//                    		action: function (dialogItself) {
//                    			dialogItself.close();
//                    		}
//                    	}]
//                    });
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
